import React, { ComponentProps } from "react";

import CreateSuspendedComponent from "containers/app/CreateSuspendedComponent";

const Component = CreateSuspendedComponent(() => import("./TeamsContainer"));

const TeamsContainer: React.FC<ComponentProps<typeof Component>> = ({
  ...props
}) => {
  return <Component {...props} />;
};

export default TeamsContainer;
